import { Link, Stack } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { policyIcon } from "~/pages/inventory/utils/policyIcon";
import { Link as RouterLink } from "react-router-dom";
import { type OrganizationPoliciesRow } from "../../hooks/useOrganizationPoliciesTableData";
import { useScope } from "~/hooks/useScope";

export const OrganizationPoliciesTableNameCell: GridColDef<OrganizationPoliciesRow>["renderCell"] =
  ({ row }) => {
    const { organizationScope } = useScope();
    return (
      <Stack direction="row" gap={2} alignItems="center">
        {policyIcon(row.name, "small")}
        <Link
          component={RouterLink}
          to={`/organization/policies/${row.encodedId}?${organizationScope?.params}`}
          sx={{
            color: "text.primary",
            ":hover": {
              color: "primary.light",
              textDecoration: "underline",
            },
          }}
        >
          {row.name}
        </Link>
      </Stack>
    );
  };
